import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import $ from "jquery";
import {
  Paper,
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  Divider,
} from "@material-ui/core";
import React, { Component } from "react";
import { formateDate, getQueryVariable } from "../utils/utilTools";
import Pagination from "@material-ui/lab/Pagination";
import { VideoLibrary, Flag, FindInPage } from "@material-ui/icons";
import SearchNoResult from "./search-noResult";

require("../assets/css/style.css");
require("../assets/css/news-style.css");
const imageAccount = require("../assets/images/top-ico1.png");
const searchTitle = require("../assets/images/gw.png");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
    },
  },
  inputText: {
    padding: "0 5px 0 0",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

class PagepreDis extends Component {
  constructor(props) {
    super();
  }

  componentWillUnmount = () => {};

  componentDidMount() {}

  componentDidCatch(error, errorInfo) {
    console.log("==============", error, errorInfo);
  }

  render() {
    return (
      <button
        class="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page MuiPaginationItem-outlined Mui-disabled Mui-disabled"
        tabindex="-1"
        type="button"
        disabled=""
        aria-label="Go to previous page"
        style={{height: "24px", borderRadius: "0px"}}
      >
        <svg
          class="MuiSvgIcon-root MuiPaginationItem-icon"
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
        </svg>
      </button>
    );
  }
}

export default withStyles(useStyles)(PagepreDis);
